module.exports = __webpack_public_path__ + "static/b3-e13f825c235ba4f30f98e171fb2c9b4c.jpg";